// Reine Regeln der Pillen-Formulare (ohne React) – testbar in form-logik.test.ts.

/** Escape schließt das Formular – außer ein Baustein hat die Taste schon verbraucht
 *  (z. B. eine aufgeklappte Auswahlliste, die zuerst zugeht). */
export function escapeSchliesstFormular(e: { key: string; defaultPrevented: boolean }): boolean {
  return e.key === 'Escape' && !e.defaultPrevented;
}

/** Ergebnisliste eines Suchfelds erst ab der Mindestlänge des jeweiligen Formulars zeigen.
 *  `trimmen` nur, wenn das Formular selbst vor dem Prüfen trimmt – die Regel muss exakt dieselbe sein. */
export function suchbegriffReicht(suche: string, mindestLaenge: number, trimmen = false): boolean {
  return (trimmen ? suche.trim() : suche).length >= mindestLaenge;
}

/** Hauptknopf: nicht klickbar, solange gespeichert wird oder das Formular ihn sperrt. */
export function knopfGesperrt(z: { gesperrt?: boolean; laedt?: boolean }): boolean {
  return !!z.gesperrt || !!z.laedt;
}

/** Zähler rechts im Abschnittskopf: „N fehlt“ vor „N Pflicht“, sonst nichts. */
export function abschnittZaehler(pflicht: number, fehlt: number): { text: string; fehlt: boolean } | null {
  if (fehlt > 0) return { text: `${fehlt} fehlt`, fehlt: true };
  if (pflicht > 0) return { text: `${pflicht} Pflicht`, fehlt: false };
  return null;
}

/** Fehlerzustand eines Formulars: Text der roten Leiste + rot markierte Felder. */
export interface FehlerZustand {
  text: string | null;
  felder: readonly string[];
}

export const KEIN_FEHLER: FehlerZustand = { text: null, felder: [] };

/** Nutzer ändert ein markiertes Feld → Markierung weg; war es das letzte, verschwindet
 *  auch die Leiste (Prototyp `set()`). Fehler ohne Feldbezug (Server) bleiben stehen. */
export function feldKorrigiert(z: FehlerZustand, feld: string): FehlerZustand {
  if (!z.felder.includes(feld)) return z;
  const felder = z.felder.filter(f => f !== feld);
  return { text: felder.length ? z.text : null, felder };
}

/** Passt eine abgelegte Datei zum accept-Attribut des Dateifelds? (Ablegen umgeht den Dateidialog.) */
export function passtZuAccept(datei: { name: string; type: string }, accept: string): boolean {
  const name = datei.name.toLowerCase();
  const typ = datei.type.toLowerCase();
  return accept.split(',').map(a => a.trim().toLowerCase()).filter(Boolean).some(a => {
    if (a.startsWith('.')) return name.endsWith(a);
    if (a.endsWith('/*')) return typ.startsWith(a.slice(0, -1));
    return typ === a;
  });
}

/** Text einer Ausnahme wie im bisherigen Code `e?.message || ersatz`. */
export function fehlerMeldung(e: unknown, ersatz: unknown): string {
  const m = typeof e === 'object' && e !== null && 'message' in e ? (e as { message?: unknown }).message : undefined;
  return String(m || ersatz);
}

